import React from 'react';
import { Route } from 'react-router-dom';
import { TodoPage } from './TodoPage';

export const routes = [<Route key="1" path="/properties/:propertyId/todo" component={TodoPage} />];

export const navigation = [{ name: 'Todo', link: '/Todo' }];
